/*
 * Authors: mariushirjanu
 * Created: 28/02/2023
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CartComponent } from './cart/cart.component';
import { CatalogOverviewLayoutTabularbasicComponent } from './catalog/overview/catalog-overview-layout-tabularbasic.component';
import { CartPopupComponent } from './cart/cart-popup.component';
import { AddToCartComponent } from './cart/add-to-cart.component';
import { ProposeAlternativesComponent } from './cart/propose-alternatives.component';
import { PartConfiguratorService } from './cart/part-configurator.service';
import { PartConfiguratorDataService } from './cart/part-configurator-data.service';
import { PartConfiguratorDialogComponent } from './cart/part-configurator-dialog.component';
import { PartNotAvailablePopupComponent } from './cart/popup/part-not-available-popup.component';
import { EOLPopupComponent } from './cart/popup/eol-popup.component';

@NgModule({
  declarations: [
    CatalogOverviewLayoutTabularbasicComponent,
    AddToCartComponent,
    CartComponent,
    CartPopupComponent,
    ProposeAlternativesComponent,
    PartConfiguratorDialogComponent,
    PartNotAvailablePopupComponent,
    EOLPopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BsDropdownModule
  ],
  providers: [
    PartConfiguratorService,
    PartConfiguratorDataService
  ],
  exports: [
    CatalogOverviewLayoutTabularbasicComponent,
    AddToCartComponent,
    CartComponent,
    CartPopupComponent,
    ProposeAlternativesComponent,
    PartConfiguratorDialogComponent,
    PartNotAvailablePopupComponent,
    EOLPopupComponent
  ]
})
export class OrderSharedModule {
}